import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gestionriesgos',
  templateUrl: './gestionriesgos.component.html',
  styleUrls: ['./gestionriesgos.component.css']
})
export class GestionriesgosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
